import TablePagination from '@material-ui/core/TablePagination';
import styled from 'styled-components';

export const StyledTablePagination = styled(TablePagination)`
    width: fit-content;
    margin: 5px auto 0;
`;
